import { createRequestTypes } from 'common/websocket-redux';

export const BOOT = createRequestTypes('application/BOOT');
